import React, { useEffect } from "react";
import { InvitationView } from "./view";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  getInvitationDataSelector,
  isInvitaionDataLoading,
} from "features/friend-refer/redux/selectors";
import { fetchInvitation } from "features/friend-refer/redux/actions";

export const Invitation = () => {
  const { hash } = useParams();
  const dispatch = useDispatch();
  const invitationData = useSelector(getInvitationDataSelector);
  const isLoading = useSelector(isInvitaionDataLoading);

  useEffect(() => {
    dispatch(fetchInvitation(hash));
  }, []);

  return <InvitationView isLoading={isLoading} data={invitationData} />;
};
